angular.module("vgresiduos").controller("DocumentRequestListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/solicitacoes-de-documento`);
		};
	}
]);
